import React, { Component } from 'react';
import ReactSelect from 'react-select';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import withLocalize from '../withLocalize';

class SelectOption extends Component {

	handleMouseDown = (event) => {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	};

	handleMouseEnter = (event) => {
		this.props.onFocus(this.props.option, event);
	};

	handleMouseMove = (event) => {
		if (this.props.isFocused) return;
		this.props.onFocus(this.props.option, event);
	};

	render () {
		return (
			<div
				className={this.props.className}
				onMouseDown={this.handleMouseDown}
				onMouseEnter={this.handleMouseEnter}
				onMouseMove={this.handleMouseMove}
				title={this.props.option.title}
			>
				{!!this.props.option.image &&
					<img
						src={this.props.option.image}
						width="16"
						height="12"
						style={{ marginRight: '.4em' }}
						alt={this.props.option.value}
					/>
				}
				{this.props.children}
			</div>
		);
	}
}

class SelectedValue extends Component {
	render () {
		return (
			<div className="Select-value" title={this.props.value.title}>
				<span className="Select-value-label">
					{!!this.props.value.image &&
						<img
							src={this.props.value.image}
							width="16"
							height="12"
							style={{marginRight: '.4em'}}
							alt={this.props.value.value}
						/>
					}
					{this.props.children}
				</span>
			</div>
		);
	}
}

class Select extends Component {

	static propTypes = {
		clearable: PropTypes.bool,
		disabled: PropTypes.bool,
		className: PropTypes.string,
		fontAwesomeIcon: PropTypes.object,
		input: PropTypes.object,
		defaultValue: PropTypes.string,
	};

	static defaultProps = {
		clearable: false,
		disabled: false,
		className: '',
		fontAwesomeIcon: null,
	};

	onChange = (e) => {
		this.props.input.onChange(e ? e.value : '');
	};

	render() {

		const { options, translate: t } = this.props;

		const attributes = {
			onFocus: this.onFocus,
			onBlur: this.onBlur,
			onChange: this.onChange,
			disabled: this.props.disabled,
			value: this.props.input ? this.props.input.value : this.props.defaultValue,
			clearable: this.props.clearable,
			ref: input => this.inputEl = input,
			placeholder: t('Select.placeholder'),
			clearValueText: t('Select.clearValueText'),
			autoBlur: true,
			// Zakázání vybírání/vyhledávání pomocí klávesnice (především kvůli mobilům)
			inputProps: { readOnly: 'readonly' },
			optionComponent: SelectOption,
			valueComponent: SelectedValue,
		};

		return (
			<div className={`select-container ${this.props.className}`}>
				<ReactSelect
					{...attributes}
					options={options}
				/>
				<label>
					{!!this.props.fontAwesomeIcon &&
						<FontAwesomeIcon
							icon={this.props.fontAwesomeIcon}
							className="fa-margin-right"
						/>
					}
					{this.props.label}
				</label>
			</div>
		);

	}
}

export default withLocalize(Select);



// WEBPACK FOOTER //
// ./src/components/Select.jsx